<template>
    <div
        class="nav-icon"
        role="button"
        :class="{ open: open }"
        @click="$emit('click', $event)"
        alt="Menu"
    >
        <div alt="Menu"></div>
    </div>
</template>

<script>
export default {
    name: "hamburger",
    props: {
        open: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.nav-icon {
    width: 40px;
    cursor: pointer;
}

.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #fff;
    border-radius: 3px;
    content: "";
    display: block;
    height: 5px;
    margin: 7px 0;
    transition: all 0.2s ease-in-out;
}

/* Open animation */
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
</style>
